const siteConfig = {
  // Define Volt URls for _document.tsx: we avoid vtc cookie issues by not using WM proxy URLs
  baseVoltUrls: {
    production: 'https://plus.walmart.aws.reddigital.tech',
    staging: 'https://plus.walmart-stg.aws.reddigital.tech',
  },
  // Define Beacon Source URLs: used for WM+ tracking purposes in _document.tsx
  beaconSrcUrls: {
    production: 'https://beacon.walmart.com/beacon.js',
    staging: 'https://beacon.qa.walmart.com/beacon.js',
  },
  // Values are same as src urls without protocol values
  beaconBdValues: {
    production: 'beacon.walmart.com',
    staging: 'beacon.qa.walmart.com',
  },
  beaconBhValues: {
    production: 'beacon.lightest.walmart.com',
    staging: 'beacon.qa.lightest.walmart.com',
  },
  // Monarch values used in _document.tsx
  monarch: {
    sourceId: '13823972-6eef-438b-86ef-c6d2023ffc71',
    clientToken: 'ae0a7e90-9367-4a9b-aedd-04e7592d6e42',
  },
  // Defines new relic values for production and staging accounts
  newRelicConfig: {
    trustKey: '78034',
    accountID: process.env.ENVIRONMENT === 'production' ? '3767831' : '3767832',
    agentID:
      process.env.ENVIRONMENT === 'production' ? '772289984' : '772289986',
    licenseKey:
      process.env.ENVIRONMENT === 'production'
        ? 'NRBR-5749a64f9542a1b0b04'
        : 'NRBR-d8218942a368b955b7e',
    applicationID:
      process.env.ENVIRONMENT === 'production' ? '772289984' : '772289986',
  },
  // Defines new relic values for local NR account
  newRelicConfigLocal: {
    trustKey: '78034',
    accountID: '3767831',
    agentID: '772349144',
    licenseKey: 'NRBR-5749a64f9542a1b0b04',
    applicationID: '772349144',
  },
};

export default siteConfig;
